// Libraries.
import styled, { css } from 'styled-components';

export const MainCss = css`
    width: 100%;
    margin: 0 auto;
    min-width: auto;
    max-width:  calc(100% - 32px);
    padding: 0 16px;
    @media ${(props) => props.theme.screenSizes.tablet} {
        max-width: calc(100% - 64px);
        padding: 0;
    }
    @media ${(props) => props.theme.screenSizes.laptop} {
        width: 100%;
        max-width: 1254px;
    }
    @media ${(props) => props.theme.screenSizes.laptopL} {
        max-width: 1328px;
    }
`;

export const WrapperMain = styled.main`
    ${MainCss}
    @media ${(props) => props.theme.screenSizes.tablet} {
    }
    @media ${(props) => props.theme.screenSizes.laptop} {
    }
`;

export const WrapperMainContainer = styled.div`
    ${MainCss}
`;
